import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Expander, ExpanderContent } from '@fs/zion-ui'
import FooterExpansionContent from './FooterExpansionContent'

export default function FooterExpansion({ nonReligiousMode, canSeeTemple, expanderConfig, external }) {
  return (
    <Expander {...expanderConfig}>
      <ExpanderContent>
        <Suspense fallback="">
          <FooterExpansionContent nonReligiousMode={nonReligiousMode} canSeeTemple={canSeeTemple} external={external} />
        </Suspense>
      </ExpanderContent>
    </Expander>
  )
}

FooterExpansion.propTypes = {
  nonReligiousMode: PropTypes.bool,
  canSeeTemple: PropTypes.bool,
  expanderConfig: PropTypes.shape({
    open: PropTypes.bool,
    setOpen: PropTypes.func,
  }),
}
